import styled from "styled-components";
// import style from "../utils/themeStyles";

export const TopHeader = styled.header`
  width: 100%;
  padding: 10px 0;
`;
